import { useRecord } from "./useRecord";

export function useThread(threadId?: string | null) {
  return useRecord("thread", threadId);
}
